<template>
  <div :class="classes.headerOffer" v-if="headerBranding">
    <BrandText
      :class="[classes.headerTitle, { [classes.emptyText]: lineOneEmpty }]"
      styleGroup="Header Line One"
      :get="brand => brand.adTemplate.header.lineOne"
    />
    <BrandText
      :class="[classes.headerSubTitle, { [classes.emptyText]: lineTwoEmpty }]"
      styleGroup="Header Line Two"
      :get="brand => brand.adTemplate.header.lineTwo"
    />
  </div>
</template>

<script>
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";
import BrandText from "./BrandText.vue";

const useStyles = createUseStyles({
  headerTitle: {
    flex: 1,
    fontSize: "12px",
    wordBreak: "break-all"
  },
  headerSubTitle: {
    flex: 1,
    fontSize: "10px",
    fontWeight: "normal",
    wordBreak: "break-all"
  },
  headerOffer: {
    flex: 2,
    textAlign: "left"
  },
  emptyText: {
    display: "flex",
    width: "100%",
    minHeight: "16px"
  }
});

export default defineComponent({
  name: "HeaderOffer",
  components: {
    BrandText
  },
  setup() {
    const { headerBranding } = injectBrand();
    const classes = useStyles();

    const lineOneEmpty = computed(
      () => !headerBranding.value.lineOne.value.length
    );
    const lineTwoEmpty = computed(
      () => !headerBranding.value.lineTwo.value.length
    );

    return {
      lineOneEmpty,
      lineTwoEmpty,
      headerBranding,
      classes
    };
  }
});
</script>

<style></style>
